import { useRouteLoaderData } from 'react-router';
import PathwaySettingsForm from './PathwaySettingsForm';
import { useIsSavePending } from '@/stores/paramStore';
import { usePathwayParams } from '@/stores/pathwayParamsStore';

const PathwaySettings = () => {
  const isPending = useIsSavePending();
  const data = useRouteLoaderData('control-panel');
  const params = usePathwayParams();

  if (!data) {
    return null;
  }

  const { paramSchemas } = data;

  return (
    <div className="relative">
      <div className="group node">
        <PathwaySettingsForm paramSchemas={paramSchemas} params={params} />
      </div>
      <div className="absolute top-12 right-4">
        {isPending && <span className="text-xs text-gray-500">Saving...</span>}
        {isPending === false && <span className="text-xs text-gray-500">Saved</span>}
      </div>
    </div>
  );
};

export default PathwaySettings;
